export const ROUTE_PATH =
  '/reconciliation-archive-receipts/store[eq]=:store_id&archive[eq]=:archive_eq';

export const FEATURE_NAME = 'reconciliationArchiveReceiptsPage';
